import { useState, useEffect } from "react";

import { API_URL } from "../helpers";

import Alert from "../components/Alert";
import Form from "./Form";

const Volunteering = () => {
	const [details, setDetails] = useState({
		committees: [],
	});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		const init = async () => {
			const url = new URL(`${API_URL}/volunteeringInit`);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setDetails({
						committees: json.committees,
					});
					setAlert({});
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleSubmitted = (text) => {
		setAlert({
			type: "success",
			text,
		});
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<Form details={details} submitted={handleSubmitted} />
			)}
		</>
	);
};

export default Volunteering;
